<ui-panel
  panelTitle="Panel Built-In Banner Sample"
  [bannerMessage]="bannerMessage"
>
  <p>
    This panel uses the default built-in banner configuration. Click the button to set a random
    piece of wisdom as the banner message.
  </p>

  <div class="flex gap-2">
    <ui-button buttonText="Show Random Wisdom" (click)="showRandomWisdom()"></ui-button>
    <ui-button buttonText="Clear" [disabled]="!bannerMessage" (click)="bannerMessage = ''"></ui-button>
  </div>
</ui-panel>
